import React, { useState } from "react";
import { Box, Flex, Input, Button, Text, Image } from "@chakra-ui/react";
import { getRating } from "../utils/api";
import Logo from "../assets/images/drhvac.svg";
import "../App.css";
const RatingForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const msg = await getRating(email); // msg is a STRING
      setMessage(msg);
      setEmail("");
    } catch (error) {
      setMessage(error.message || "Failed to send email. Please try again.");
    }
  };

  return (
    <>
      <Flex
        justifyContent="center"
        alignItems="center"
        mt="9rem"
        classname="rating-form-container"
      >
        <Box
          as="form"
          onSubmit={handleSubmit}
          p={8}
          rounded="lg"
          boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)"
          w={{ base: "90%", sm: "400px" }}
          textAlign="center"
        >
          <div className="logo-center">
            {" "}
            <Image src={Logo} mb={25} width="8rem" />
          </div>
          <Input
            className="form-input"
            borderRadius={0}
            variant="unstyled"
            borderBottom="2px solid #1c4b7e"
            _focus={{
              outline: "none",
              borderBottom: "2px solid #1c4b7e",
              boxShadow: "none",
            }}
            _hover={{
              borderBottom: "2px solid #1c4b7e",
            }}
            type="email"
            placeholder="Enter your email"
            _placeholder={{ color: "gray.500" }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            mb={4}
          />
          <Button
            mt={6}
            bg="#00aeef"
            color="white"
            _hover={{ bg: "#1c4b7e" }}
            _focus={{
              boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
            }}
            _active={{
              bg: "#1c4b7e",
              transform: "scale(0.98)",
            }}
            size="lg"
            w="full"
            type="submit"
          >
            Submit
          </Button>
          {message && (
            <Text mt={4} color="green.500">
              {message}
            </Text>
          )}
        </Box>
      </Flex>
    </>
  );
};

export default RatingForm;
